import React, { useContext, useMemo } from 'react'
import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { aggregateData } from '../functions';
import GraphTable from '../mechanisms/graphtable';
import { formatCurrency } from '../functions';
import { currencyPrefix } from '../single-card';
import { DashboardContext } from '../mechanisms/card';
import DashView from '../mechanisms/dashview';
import dayjs from 'dayjs'

const EstimatedSales = ({ data }) => {

    const { type } = useContext(DashboardContext)

    const graph = useMemo(() => aggregateData('value', data.flatMap(d => {
      if (['ACTIVE', 'QUALIFIED'].includes(d.status) && dayjs(d.estimated_at) >= dayjs()){
        //d.
        return d
      }
      return []
    
    }), 'owner_id'), [data])

    return (
        <>
            {type === 'table' ? <GraphTable rows={graph} columns={[
                { field: 'owner_name', headerName: 'Vendedor', flex: 1, },
                { field: 'count', headerName: 'Quantidade', flex: 1, },
                {
                    field: 'value', headerName: 'Valor estimado', flex: 1,
                    renderCell: ({ value, row }) => `${currencyPrefix[row?.currency]} ${formatCurrency(value*100, row?.currency)}`
                }
            ]} />
                : <DashView name='estimatedsales' rows={graph} vx={'owner_name'} vy={['value', 'count']} renderValue={(vy, row) => {
                    if (vy === 'value')
                        return `${currencyPrefix[row?.currency]} ${formatCurrency(row[vy]*100, row?.currency)}`
                    return row[vy]
                }} />
            }
        </>
    );
}


export default EstimatedSales